module.exports = __webpack_public_path__ + "img/36_41.cf83c54e.png";